import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './driverAppDownload.module.css';

const stores = [
  {
    platform: 'iOS',
    name: 'App Store',
    href: 'https://apps.apple.com/tw/app/easyride-%E5%8F%B8%E6%A9%9F%E7%AB%AF/id6756508164',
  },
  {
    platform: 'Android',
    name: 'Google Play',
    href: 'https://play.google.com/store/apps/details?id=com.easyride.driverapp',
  },
];

export default function DriverAppDownload() {
  useEffect(() => {
    document.title = '下載 Easyride 司機端 App | Goto Airport';
  }, []);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to="/" className={styles.brand}>Goto Airport</Link>
      </header>
      <main className={styles.main}>
        <div className={styles.content}>
          <p className={styles.eyebrow}>DRIVER APP</p>
          <h1>下載 Easyride 司機端 App</h1>
          <p className={styles.intro}>選擇您的手機系統，前往官方商店下載。</p>
          <div className={styles.storeList}>
            {stores.map(({ platform, name, href }) => (
              <a className={styles.storeLink} href={href} key={platform} target="_blank" rel="noopener noreferrer">
                <span className={styles.storeText}>
                  <span className={styles.platform}>{platform}</span>
                  <strong>前往 {name}</strong>
                </span>
                <span className={styles.arrow} aria-hidden="true">↗</span>
              </a>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
